<template>
  <div class="stub-wrap">
    <transition name="fade">
    <div class="stub" v-show="imageIsNotLoaded">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 65 20" class="stub__axis">
        <path stroke="#E6E6E6" stroke-dasharray="1 4" d="M1 0v19h64"/>
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 65 12" class="stub__chart">
        <path stroke="#E6E6E6" d="M1 4.774l9.49 5.738a1 1 0 0 0 .936.053l13.842-6.379a1 1 0 0 1 .813-.01l15.022 6.44a1 1 0 0 0 .793-.002L64 1"/>
      </svg>
    </div>
    </transition>
    <img
      class="chart"
      :src="imageSrc"
      @load="hideStub()"
      v-if="chartIsAvailableForLoad"
      v-show="!imageIsNotLoaded"
    >
    </div>
</template>


<script>
import { mapGetters, mapState } from 'vuex';
import { apiUrl } from 'src/utils/config';

export default {
  data: () => ({
    imageIsNotLoaded: true,
  }),
  props: {
    tickerId: Number,
    src: String,
  },
  computed: {
    ...mapGetters('userData', ['currencyCode', 'settingsIsLoaded']),
    ...mapState('userData', ['loginInfo']),
    apiUrl: () => apiUrl,
    chartIsAvailableForLoad() {
      return !this.loginInfo || (this.settingsIsLoaded && this.loginInfo);
    },
    imageSrc() {
      if (this.src) {
        return `${apiUrl}${this.src}`;
      }
      return `${apiUrl}/images/ticker/sparkline/price/${this.currencyCode}/${this.tickerId}/preview.svg`;
    },
  },
  methods: {
    hideStub() {
      this.imageIsNotLoaded = false;
    },
  },
};
</script>

<style lang="scss" scoped>
  $stub-height: 19px;
  .stub-wrap {
    position: relative;
    height: $stub-height;
  }
  .stub {
    width: 64px;
    height: $stub-height;
    position: absolute;
    &__chart {
      position: absolute;
      top: 0;
      left: 1px;
      animation: chart 2s infinite;
    }
  }

  .chart {
    width: 64px;
  }

  @keyframes chart {
    0% {
      clip-path: inset(0% 100% 0% 0%);
    }
    20% {
      clip-path: inset(0% 83% 0% 0%);
    }

    40% {
      clip-path: inset(0% 61% 0% 0%);
    }

    60% {
      clip-path: inset(0% 36% 0% 0%);
    }

    80% {
      clip-path: inset(0% 0% 0% 0%);
    }

    100% {
      clip-path: inset(0% 0% 0% 100%);
    }
  }

  .fade-enter-active {
  // .fade-leave-active {
    transition: opacity $transition;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/uikit/GraphEl.vue